import React from "react";
import "./quill.snow.css";
import { Text } from "../../../components";
import ReactQuill from 'react-quill-new';

interface TextEditorProps {
  value: string;
  onChange: (content: string) => void;
  title?: string;
  subtitle?: string;
  height?: string;
}

export const TextEditor: React.FC<TextEditorProps> = ({
  value,
  onChange,
  title,
  subtitle,
  height = "200px",
}) => {
  return (
    <div>
      {title && <Text.Body2XS color="darkGrey">{title}</Text.Body2XS>}
      <br />
      {subtitle && <Text.Body2XS marginTop={2}>{subtitle}</Text.Body2XS>}
      <div style={{ marginTop: "1rem", marginBottom: "2rem" }}>
        <ReactQuill
          value={value}
          onChange={(content, delta, source, editor) => {
            if (source === 'user') {
              onChange(content);
            }
          }}
          modules={{
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link", "image"],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["clean"],
            ],
          }}
          style={{ height, marginBottom: "50px" }}
        />
      </div>
    </div>
  );
};
